import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import { useFragment } from "react-relay";

import { CurrentBookingWizardStepAtom } from "../../atoms/stores";
import { TimeSlotWizardStepContainerNode$key } from "./__generated__/TimeSlotWizardStepContainerNode.graphql";
import { AddPlayersPrivateStep } from "./steps/AddPlayersPrivateStep/AddPlayersPrivateStep";
import { AddPlayersPrivateStepClientProfile$key } from "./steps/AddPlayersPrivateStep/__generated__/AddPlayersPrivateStepClientProfile.graphql";
import { AddPlayersStep } from "./steps/AddPlayersStep/AddPlayersStep";
import { AddPlayersStepClientProfile$key } from "./steps/AddPlayersStep/__generated__/AddPlayersStepClientProfile.graphql";
import { TimeSlotBookingDetailsStep } from "./steps/BookingDetailsStep/TimeSlotBookingDetailsStep";
import { PreviousBookingsStep } from "./steps/PreviousBookingsStep/PreviousBookingsStep";
import { PreviousBookingsStepClientProfile$key } from "./steps/PreviousBookingsStep/__generated__/PreviousBookingsStepClientProfile.graphql";

type Props = {
  nodeRef: TimeSlotWizardStepContainerNode$key | null;
  addPlayersRef: AddPlayersStepClientProfile$key | null;
  addPlayersPrivateRef: AddPlayersPrivateStepClientProfile$key | null;
  previousBookingsRef: PreviousBookingsStepClientProfile$key | null;
  onClose: () => void;
  memberId: string;
  initiallyLockedSlotIds?: readonly string[];
};

export const TimeSlotWizardStepContainer = ({
  nodeRef,
  addPlayersRef,
  addPlayersPrivateRef,
  previousBookingsRef,
  onClose,
  memberId,
  initiallyLockedSlotIds,
}: Props) => {
  const node = useFragment(
    TimeSlotWizardStepContainerNodeFragmentString,
    nodeRef
  );
  const currentBookingWizardStep = useAtomValue(CurrentBookingWizardStepAtom);

  switch (currentBookingWizardStep) {
    case "BookingDetails":
      return (
        <TimeSlotBookingDetailsStep
          nodeRef={node ?? null}
          memberId={memberId}
          initiallyLockedSlotIds={initiallyLockedSlotIds}
          onClose={onClose}
        />
      );
    case "AddPlayers":
      return (
        <AddPlayersStep
          clientProfileRef={addPlayersRef}
          nodeRef={node ?? null}
        />
      );
    case "AddPlayersPrivate":
      return (
        <AddPlayersPrivateStep
          nodeRef={node ?? null}
          clientProfileRef={addPlayersPrivateRef}
        />
      );
    case "PreviousBookings":
      return (
        <PreviousBookingsStep
          previousBookingsRef={previousBookingsRef}
          previousBookingsTimeSlotRef={node ?? null}
          onClose={onClose}
        />
      );
    default:
      return null;
  }
};

export const TimeSlotWizardStepContainerNodeFragmentString = graphql`
  fragment TimeSlotWizardStepContainerNode on Node
  @argumentDefinitions(
    memberId: { type: "ID", defaultValue: null }
    membershipTypeId: { type: "ID", defaultValue: null }
  ) {
    ...TimeSlotBookingDetailsStepNode
      @arguments(memberId: $memberId, membershipTypeId: $membershipTypeId)
    ...AddPlayersStepNode
    ...AddPlayersPrivateStepNode
    ...PreviousBookingsStep_TimeSlot
  }
`;
